<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/contentSection' }"
                >内容专区运营</el-breadcrumb-item
              >
              <el-breadcrumb-item>
                {{ rid ? "编辑版块" : "新建版块" }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">版块基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="showPlate" label-width="120px">
              <el-form-item label="版块名称:">
                <el-input
                  v-model.trim="showPlate.name"
                  placeholder="请输入内容"
                  style="width: 220px"
                ></el-input>
              </el-form-item>
              <br />
              <el-form-item label="选择资源类型:">
                <el-select
                  v-model="showPlate.levelValue"
                  clearable
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br v-if="showPlate.levelValue != 3">
              <p style="color: red; font-weight: bold;margin-left: 40px;" v-if="showPlate.levelValue == 3">*听力熊T3，T4系列不支持多层专辑显示</p>
              <el-form-item label="添加资源:">
                <div
                  v-for="(item, index) in showPlate.resourceList"
                  :key="index"
                  style="width: 500px"
                >
                  <el-row style="margin-bottom: 8px">
                    <el-col :span="10">
                      <p style="color: #2222dd">{{ item.name }}</p>
                    </el-col>
                    <el-col :span="6">
                      <p style="color: #2222dd"><span v-if="item.layerType==1">单层专辑</span><span v-if="item.layerType==2">多层专辑</span></p>
                    </el-col>
                    <el-col :span="2">
                      <a href="javascript:;" @click="delRight(index)">
                        <Icon
                          type="ios-remove-circle-outline"
                          size="30"
                          color="#C5C5C5"
                        />
                      </a>
                    </el-col>
                  </el-row>
                </div>
                <addClassResource
                  :typeValue="showPlate.levelValue"
                  @changeResource="clickRecource"
                />
              </el-form-item>
              <br />
              <el-form-item label="版块图片">
                <!-- {{ showPlate.imgUrl }} -->
                <el-row class="row-bg" style="width: 780px">
                  <el-col
                    :span="24"
                    class="picture-container"
                    :class="{ 'limt-1': showPlate.imgUrl }"
                  >
                    <!-- list-type="picture-card" -->
                    <!-- {{ showPlate.imgUrl }} -->
                    <!-- class="avatar-uploader" -->
                    <el-upload
                      list-type="picture-card"
                      ref="uploadxls"
                      :limit="1"
                      :fileList="fileList"
                      action="/aries-api/resource/upload"
                      :before-upload="onBeforeUpload"
                      :on-success="onSuccessUpload"
                      :data="uploadData"
                      :auto-upload="true"
                    >
                      <i slot="default" class="el-icon-upload"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="showPlate.imgUrl"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <!-- <span
                            class="el-upload-list__item-delete"
                            @click="handleDownload(file)"
                          >
                            <i class="el-icon-download"></i>
                          </span> -->
                          <span
                            class="el-upload-list__item-delete"
                            @click="handleRemove(file)"
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <!-- <i
                        v-show="!showPlate.imgUrl.length"
                        class="el-icon-upload avatar-uploader-icon"
                      ></i> -->
                      <!-- <img :src="showPlate.imgUrl" alt="" /> -->
                      <div
                        style="font-size: 12px"
                        slot="tip"
                        class="el-upload__text upload__tip"
                      >
                        *上传图片尺寸为220*72
                      </div>
                    </el-upload>
                  </el-col>
                  <!-- <el-col :span="4" v-if="showPlate.imgUrl != ''">
                    <el-button
                      size="small"
                      type="danger"
                      @click="delFrontCover"
                      icon="el-icon-delete"
                      >删除</el-button
                    >
                  </el-col> -->
                </el-row>

                <el-button
                  type="primary"
                  style="
                    background-color: #009e7d;
                    margin-top: 20px;
                    width: 220px;
                  "
                  @click="createShow"
                  >设计图片</el-button
                >
              </el-form-item>

              <br />
            </el-form>
          </div>
        </div>
      </Card>
      <div style="display: flex; justify-content: center">
        <el-button @click="cencel">取消</el-button>
        <el-button
          type="primary"
          style="background-color: #009e7d"
          @click="confirmSubmit"
          >确定</el-button
        >
      </div>
    </div>
    <create-picture v-model="pickShow" @getData="getData"></create-picture>
  </div>
</template>

<script>
import addClassResource from "./addClassResource.vue";
import { ApiMessage, formatDate } from "@/utils/util";
import createPicture from "./components/createPicture.vue";

export default {
  name: "addSection",
  components: {
    addClassResource,
    createPicture,
  },
  data() {
    return {
      queryData: [],
      showPlate: {
        name: "",
        imgUrl: "",
        levelValue: "",
        resourceList: [],
      },
      levelList: [
        {
          value: 1,
          label: "体系课",
        },
        {
          value: 2,
          label: "特色课程",
        },
        {
          value: 3,
          label: "音频资源",
        },
      ],
      uploadData: { isOnlyMP3: "false", pdfToPng: "false" },
      type: [],
      rid: "",
      doWhat: "",
      newArr: [],
      pickShow: false,
      fileList: [],
      files: "",
    };
  },
  watch: {
    "showPlate.levelValue"(newVal, oldVal) {
      console.log(
        newVal,
        oldVal,
        "--------------------------------------------newValnewValnewVal"
      );
      if (!this.rid && newVal != oldVal) {
        this.type = [];
        this.showPlate.resourceList = [];
        this.newArr = [];
      }
      if (this.rid && newVal != oldVal && oldVal != "") {
        this.type = [];
        this.showPlate.resourceList = [];
        this.newArr = [];
      }
    },
  },
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
    formatDate3(d) {
      return formatDate(d, "yyyy-MM-dd");
    },
    getUsedCnt(row) {
      if (row.personLimit == 0) {
        return `${row.usedCnt}/${"不限"}`;
      } else {
        return `${row.usedCnt}/${row.personLimit}`;
      }
    },
  },
  created() {
    // this.changeResourceList();
    this.doWhat = this.$route.query.do;
    if (this.$route.query.sectId) {
      this.rid = this.$route.query.sectId;
      // this.saveinviteCode();
      let params = {
        appId: this.$API.APPID,
        secId: String(this.rid),
      };
      this.$axios
        .post("/edu/eduAdmin/contentzone/section_detail", params)
        .then((response) => {
          console.log(
            response,
            "response.data.data.resList",
            response.data.data.resList
          );
          let _data = JSON.parse(JSON.stringify(response.data.data));
          let newArr = _data.resList.map((item) => {
            return { id: Number(item.resId), name: item.resName,layerType: item.layerType };
          });
          if (response.data.rc == "0") {
            this.showPlate.name = _data.name;
            this.showPlate.imgUrl = _data.cover;
            this.fileList = [{ url: _data.cover }];
            this.showPlate.levelValue = _data.type;
            this.showPlate.resourceList = newArr;
            // rsList=_data.resList
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    }
    // this.initlist();
  },
  methods: {
 

    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },

    clickRecource(data) {
      if (data.length == 0) {
        return;
      }

      for (let i = 0; i < data.length; i++) {
        this.type.push(data[i]);
      }
      console.log();
      let res_list = [];
      // console.log(res_list);
      // this.showPlate.resourceList = [...new Set(this.type)];
      if (this.rid && this.showPlate.resourceList.length > 0) {
        console.log("you ");
        res_list = this.showPlate.resourceList.concat([...new Set(this.type)]);
        let obj = {};
        this.showPlate.resourceList = res_list.reduce((pre, cur) => {
          obj[cur.id] ? "" : (obj[cur.id] = true && pre.push(cur));
          return pre;
        }, []);

        console.log(this.showPlate.resourceList);
      } else {
        this.showPlate.resourceList = [...new Set(this.type)];
      }

      console.log(this.showPlate.resourceList, "this.showPlate.resourceList");
    },
    cencel() {
      this.$router.push({
        path: "/contentSection",
      });
    },
    confirmSubmit() {
      console.log(this.showPlate);
      let params = {
        appId: this.$API.APPID,
        name: this.showPlate.name,
        type: Number(this.showPlate.levelValue),
        cover: this.showPlate.imgUrl,
      };
      if (this.rid != "") {
        params.secId = String(this.rid);
      } else {
        params.secId = "0";
      }
      if (this.showPlate.name == "") {
        alert("版块名称不能为空");
        return;
      }
      if (this.showPlate.levelValue == "") {
        alert("选择资源类型");
        return;
      }
      if (!this.showPlate.imgUrl) {
        alert("请上传版块图片");
        return;
      }
      if (this.showPlate.resourceList.length > 0) {
        params.resList = this.showPlate.resourceList.map((item) => {
          return String(item.id);
        });
      } else {
        params.resList = [];
      }
      this.$axios
        .post("/edu/eduAdmin/contentzone/section_save", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$Message.success("操作成功!");
            this.cencel();
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    delRight(index) {
      this.type.splice(index, 1);
      this.showPlate.resourceList.splice(index, 1);
      this.newArr.splice(index, 1);
      console.log(index);
    },
    onBeforeUpload(file) {
      var imgSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      let validExts = ["jpeg", "png", "jpg"];
      imgSuffix = imgSuffix.toLocaleLowerCase();
      if (!validExts.includes(imgSuffix)) {
        this.$message.error("图片上传格式只支持" + validExts.join(",") + "格式");
        return false;
      }
      return this.checkImageWH(file, 220, 72);
    },
    onSuccessUpload(response, file, fileList) {
      this.showPlate.imgUrl = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    uploadSectionFile() {},
    handleRemove() {
      this.showPlate.imgUrl = "";
      this.fileList = [];
    },

    detailBeforeUpload(file) {},
    // 显示图片宽高
    checkImageWH(file, width, height) {
      // let self = this;
      return new Promise(function (resolve, reject) {
        let filereader = new FileReader();
        filereader.onload = (e) => {
          let src = e.target.result;
          const image = new Image();
          image.onload = function () {
            if (width && this.width != width) {
              alert(
                "请上传宽为" + width + "px的图片和高为" + height + "px的图片"
              );
              reject();
            } else if (height && this.height != height) {
              alert(
                "请上传高为" + height + "px的图片和宽为" + width + "px的图片"
              );
              reject();
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };
        filereader.readAsDataURL(file);
      });
    },
    handleSelectionChange() {},
    handleInvitationDetail(row) {
      const routeData = this.$router.resolve({
        path: "/invitationDetail",
        query: row,
      });
      window.open(routeData.href, "_blank");
    },
    saveinviteCode() {
      let params = {
        appId: this.$API.APPID,
        targetId: String(this.rid),
      };
      this.$axios
        .post("/edu/eduAdmin/hxd/invite_code_list", params)
        .then((response) => {
          console.log(response);
          if (response.data.rc == "0") {
            this.queryData = response.data.data;
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    // 新加
    createShow() {
      this.pickShow = true;
    },
    getData(list) {
      if (list && list.length) {
        this.fileList = list;

        this.showPlate.imgUrl = list[0].url;
      }
      // this.fileList = [];
      // this.fileList.push({
      //   name: "设计" + Date.now() + ".png",
      //   url: res.previewBlobUrl,
      // });
      // this.saveData();
    },

    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("package_del") != -1 ||
                address.indexOf("package_batch") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.picture-container {
  .el-upload--picture-card {
    width: 220px;
    height: 72px;
    line-height: 87px;
  }
  .el-upload-list--picture-card {
    width: 220px;
    height: 72px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 220px;
    height: 72px;
    // line-height: 80px;
  }
}
.limt-1 {
  .el-upload--picture-card {
    display: none;
  }
}

.panel-title {
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  padding-left: 10px;
  line-height: 20px;
  border-left: 4px solid #009e7d;
}

.panel-content {
  margin-bottom: 30px;
}
.avatar-uploader {
  display: flex;
  flex-direction: column;
}

.avatar-uploader >>> .el-upload {
  width: 220px;
  height: 72px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 72px;
  line-height: 72px;
  text-align: center;
}
.avatar {
  width: 220px;
  height: 72px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// addSection.vue?7988be7c